export const footerLinks = {
    'jo-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://jo.wingie.com/flights/to-riyadh/',
                    title: 'رياض',
                },
                {
                    href: 'https://jo.wingie.com/flights/to-jeddah/',
                    title: 'جدة',
                },
                {
                    href: 'https://jo.wingie.com/flights/to-dammam/',
                    title: 'الدمام',
                },
                {
                    href: 'https://jo.wingie.com/flights/to-manila/',
                    title: 'مانيلا',
                },
                {
                    href: 'https://jo.wingie.com/flights/to-chennai/',
                    title: 'تشيناي',
                },
                {
                    href: 'https://jo.wingie.com/flights/to-delhi/',
                    title: 'دلهي',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://jo.wingie.com/flights/az-azerbaijan/',
                    title: 'أذربيجان',
                },
                {
                    href: 'https://jo.wingie.com/flights/bh-bahrain/',
                    title: 'البحرين',
                },
                {
                    href: 'https://jo.wingie.com/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://jo.wingie.com/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://jo.wingie.com/flights/jo-jordan/',
                    title: 'الأردن',
                },
                {
                    href: 'https://jo.wingie.com/flights/ke-kenya/',
                    title: 'كينيا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://jo.wingie.com/flights/airlines/saudi-arabian-airlines/',
                    title: 'السعودية',
                },
                {
                    href: 'https://jo.wingie.com/flights/airlines/flynas/',
                    title: 'طيران ناس',
                },
                {
                    href: 'https://jo.wingie.com/flights/airlines/qatar-airways/',
                    title: 'الخطوط الجوية القطرية\n',
                },
                {
                    href: 'https://jo.wingie.com/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://jo.wingie.com/flights/airlines/etihad-airways/',
                    title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
                },
                {
                    href: 'https://jo.wingie.com/flights/airlines/royal-jordanian/',
                    title: 'الملكيَّة الأردنيَّة',
                },
            ],
        },
    ],
    'jo-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://jo.wingie.com/en/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://jo.wingie.com/en/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/bd-bangladesh/',
                    title: 'Bangladesh',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/jo-jordan/',
                    title: 'Jordan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/flyadeal/',
                    title: 'flyadeal',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/nile-air/',
                    title: 'Nile Air',
                },
                {
                    href: 'https://jo.wingie.com/en/flights/airlines/emirates/',
                    title: 'Emirates',
                },
            ],
        },
    ],
    'jo-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/a-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://jo.wingie.com/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/es/vuelos/companias-aereas/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://jo.wingie.com/de/flug/nach-riad/',
                    title: 'Riad',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/nach-dschidda/',
                    title: 'Dschidda',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/nach-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/nach-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/nach-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/nach-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://jo.wingie.com/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/jo-jordanien/',
                    title: 'Jordanien',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/ke-kenia/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/de/flug/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://jo.wingie.com/ru/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/to-jeddah/',
                    title: 'Джедда',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://jo.wingie.com/ru/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/ru/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://jo.wingie.com/it/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://jo.wingie.com/it/flights/az-azerbaijan/',
                    title: 'Azerbaigian',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/eg-egypt/',
                    title: 'Egitto',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/jo-jordan/',
                    title: 'Giordania',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/it/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://jo.wingie.com/fr/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/to-manila/',
                    title: 'Manille',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://jo.wingie.com/fr/flights/az-azerbaijan/',
                    title: 'Azerbaïdjan',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/bh-bahrain/',
                    title: 'Bahreïn',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/eg-egypt/',
                    title: 'Égypte',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/in-india/',
                    title: 'Inde',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/jo-jordan/',
                    title: 'Jordanie',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/ke-kenya/',
                    title: 'Kenya',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/fr/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://jo.wingie.com/pt/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://jo.wingie.com/pt/flights/az-azerbaijan/',
                    title: 'Azerbaijão',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/eg-egypt/',
                    title: 'Egito',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/in-india/',
                    title: 'Índia',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/jo-jordan/',
                    title: 'Jordânia',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/ke-kenya/',
                    title: 'Quénia',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/pt/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://jo.wingie.com/ro/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://jo.wingie.com/ro/flights/az-azerbaijan/',
                    title: 'Azerbaidjan',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/jo-jordan/',
                    title: 'Iordania',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/ke-kenya/',
                    title: 'Kenya',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/ro/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://jo.wingie.com/pl/flights/to-riyadh/',
                    title: 'Rijad',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/to-jeddah/',
                    title: 'Dżudda',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://jo.wingie.com/pl/flights/az-azerbaijan/',
                    title: 'Azerbejdżan',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/bh-bahrain/',
                    title: 'Bahrajn',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/eg-egypt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/in-india/',
                    title: 'Indie',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/pl/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://jo.wingie.com/lt/flights/to-riyadh/',
                    title: 'Rijadas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/to-jeddah/',
                    title: 'Džidda',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/to-dammam/',
                    title: 'Damamas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/to-chennai/',
                    title: 'Čenajus',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/to-delhi/',
                    title: 'Delis',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://jo.wingie.com/lt/flights/az-azerbaijan/',
                    title: 'Azerbaidžanas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/bh-bahrain/',
                    title: 'Bahreinas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/eg-egypt/',
                    title: 'Egiptas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/in-india/',
                    title: 'Indija',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/jo-jordan/',
                    title: 'Jordanija',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/ke-kenya/',
                    title: 'Kenija',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/lt/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://jo.wingie.com/uz/flights/to-riyadh/',
                    title: 'Riyod',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/to-jeddah/',
                    title: 'Jidda',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/to-delhi/',
                    title: 'Dehli',
                },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                {
                    href: 'https://jo.wingie.com/uz/flights/az-azerbaijan/',
                    title: 'Ozarbayjon',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/bh-bahrain/',
                    title: 'Bahrayn',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/eg-egypt/',
                    title: 'Misr',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/in-india/',
                    title: 'Hindiston',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/jo-jordan/',
                    title: 'Iordaniya',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/ke-kenya/',
                    title: 'Keniya',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/uz/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-sr': [
        {
            title: 'Најпопуларније дестинације',
            items: [
                {
                    href: 'https://jo.wingie.com/sr/flights/to-riyadh/',
                    title: 'Ријад',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/to-jeddah/',
                    title: 'Џеда',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/to-dammam/',
                    title: 'Дамам',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/to-chennai/',
                    title: 'Ченај',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/to-delhi/',
                    title: 'Делхи',
                },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                {
                    href: 'https://jo.wingie.com/sr/flights/az-azerbaijan/',
                    title: 'Азербејџан',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/bh-bahrain/',
                    title: 'Бахреин',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/eg-egypt/',
                    title: 'Египат',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/in-india/',
                    title: 'Индија',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/jo-jordan/',
                    title: 'Јордан',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/ke-kenya/',
                    title: 'Кенија',
                },
            ],
        },
        {
            title: 'Популарне авиокомпаније',
            items: [
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/sr/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://jo.wingie.com/ky/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/to-jeddah/',
                    title: 'Жидда',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://jo.wingie.com/ky/flights/az-azerbaijan/',
                    title: 'Азербайжан',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/ky/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-tg': [
        {
            title: 'Шаҳрҳои машҳур',
            items: [
                {
                    href: 'https://jo.wingie.com/tg/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/to-jeddah/',
                    title: 'Ҷидда',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/to-delhi/',
                    title: 'Деҳли',
                },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                {
                    href: 'https://jo.wingie.com/tg/flights/az-azerbaijan/',
                    title: 'Озарбойҷон',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/bh-bahrain/',
                    title: 'Баҳрайн',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/eg-egypt/',
                    title: 'Миср',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/in-india/',
                    title: 'Ҳиндустон',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/jo-jordan/',
                    title: 'Урдун',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Ширкатҳои машҳури авиатсионӣ',
            items: [
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/tg/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                {
                    href: 'https://jo.wingie.com/kk/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/to-jeddah/',
                    title: 'Жидда',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://jo.wingie.com/kk/flights/az-azerbaijan/',
                    title: 'Әзербайжан',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/in-india/',
                    title: 'Үндістан',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/kk/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://jo.wingie.com/nl/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/to-manila/',
                    title: 'Manilla',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/to-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/to-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://jo.wingie.com/nl/flights/az-azerbaijan/',
                    title: 'Azerbeidzjan',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/bh-bahrain/',
                    title: 'Bahrein',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/eg-egypt/',
                    title: 'Egypte',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/jo-jordan/',
                    title: 'Jordanië',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://jo.wingie.com/nl/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'jo-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://jo.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://jo.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://jo.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://jo.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://jo.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://jo.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://jo.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://jo.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://jo.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://jo.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://jo.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://jo.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://jo.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://jo.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://jo.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://jo.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://jo.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://jo.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://jo.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://jo.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://jo.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://jo.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://jo.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://jo.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://jo.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://jo.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://jo.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://jo.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://jo.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://jo.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://jo.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://jo.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://jo.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://jo.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://jo.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://jo.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://jo.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://jo.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://jo.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://jo.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://jo.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://jo.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://jo.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://jo.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://jo.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://jo.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://jo.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://jo.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://jo.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://jo.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://jo.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://jo.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://jo.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://jo.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://jo.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://jo.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://jo.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://jo.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://jo.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://jo.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://jo.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://jo.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://jo.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://jo.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://jo.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://jo.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://jo.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://jo.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://jo.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://jo.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://jo.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://jo.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://jo.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://jo.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://jo.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://jo.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://jo.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://jo.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://jo.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://jo.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://jo.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://jo.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://jo.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://jo.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://jo.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://jo.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://jo.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://jo.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://jo.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://jo.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://jo.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://jo.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://jo.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://jo.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://jo.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://jo.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://jo.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://jo.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://jo.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://jo.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://jo.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://jo.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://jo.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://jo.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://jo.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://jo.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://jo.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://jo.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://jo.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://jo.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://jo.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://jo.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://jo.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://jo.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://jo.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://jo.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://jo.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://jo.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://jo.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'jo-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://jo.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://jo.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://jo.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://jo.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://jo.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://jo.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://jo.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://jo.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://jo.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://jo.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://jo.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://jo.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://jo.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://jo.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://jo.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://jo.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://jo.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://jo.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}